import React from "react";
import { AxiosError } from "axios";
import { MakeRequest } from "../DataUtil";
import SmallSpinner from "../SmallSpinner";
import Checkbox from "../../components/Checkbox";
import { sanitizeInput, Validator } from "../Validation/Validator";
import {
  getAllFormElements,
  showValidationErrors,
  resetValidationErrors,
  Redirect,
} from "../Utilities";
import ValidationSummary from "../Validation/ValidationSummary";
import { getCustomStyles } from "../../components/Utilities";
import Select from "react-select";

let sizeOptions: any[];

interface Props {
  paintingId: string;
  onToaster: any;
  onDelete: any;
}

interface State {
  paintingName: string;
  title: string;
  medium: string;
  sizeValue: string;
  sizeId: number;
  price: number;
  discount: number;
  isSold: boolean;
  isLoading: boolean;
  noData: boolean;
  formErrors: any;
  renderCount: number;
  redirect: boolean;
  image: any;
  sizes: any;
  selectedSize: any;
}

class PaintingAdminForm extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      paintingName: "",
      title: "",
      medium: "",
      sizeValue: "",
      sizeId: 0,
      price: 0,
      discount: 0,
      isSold: false,
      isLoading: false,
      noData: false,
      formErrors: [],
      renderCount: 0,
      redirect: false,
      image: {},
      sizes: [],
      selectedSize: null,
    };
    this.handlePaintingUpdate = this.handlePaintingUpdate.bind(this);
    this.handleTitleChange = this.handleTitleChange.bind(this);
    this.handlePriceChange = this.handlePriceChange.bind(this);
    this.handleDiscountChange = this.handleDiscountChange.bind(this);
    this.handleMediumChange = this.handleMediumChange.bind(this);
    this.handleSizeChange = this.handleSizeChange.bind(this);
    this.handleCheckBoxChange = this.handleCheckBoxChange.bind(this);
    this.handleImageChange = this.handleImageChange.bind(this);
    this.handleDeleting = this.handleDeleting.bind(this);
  }
  loadSizes = async (): Promise<any> => {
    const successCallback = (result: any): void => {
      if (result && result.Success) {
        this.setState(
          {
            sizes: result.Data,
          },
          () => {
            sizeOptions = this.state.sizes.map((item: any) => {
              return { label: item.SizeValue, value: item.SizeId };
            });
            this.setState({ renderCount: this.state.renderCount + 1 });
          }
        );
      }
    };
    const errorCallback = (error: AxiosError): void => {
      if (error) {
        console.log(error.response ? error.message : "Unknown Error");
      }
    };
    MakeRequest({
      url: "Painting/GetAllSizes",
      method: "get",
      data: {},
      successCallback,
      errorCallback,
    });
  };
  async loadData(): Promise<any> {
    const successCallback = (result: any): void => {
      if (
        result &&
        result.Success &&
        result.Data &&
        result.Data !== undefined
      ) {
        this.setState({
          paintingName: result.Data.PaintingName,
          title: result.Data.Title,
          medium: result.Data.Medium,
          sizeValue: result.Data.Size,
          sizeId: result.Data.SizeId,
          price: result.Data.Price,
          discount: result.Data.Discount,
          isSold: result.Data.IsSold,
          noData: false,
          isLoading: false,
          renderCount: this.state.renderCount + 1,
          selectedSize: {
            label: result.Data.Size,
            value: result.Data.SizeId,
          },
        });
      } else {
        this.setState({ isLoading: false, noData: true });
      }
    };
    const errorCallback = (error: AxiosError): void => {
      if (error) {
        this.setState({ isLoading: false, noData: true }, () => {
          this.props.onToaster(
            { error: true },
            error.response ? error.message : "Unknown Error"
          );
        });
      }
    };
    this.setState({ isLoading: true }, () => {
      MakeRequest({
        url: "Painting/GetPaintingDetails",
        method: "get",
        data: {
          querystringParams: "/'" + this.props.paintingId,
        },
        successCallback,
        errorCallback,
      });
    });
  }
  postData(data: any): void {
    //process results from ajax call
    const successCallback = (result: any): void => {
      if (result && result !== undefined) {
        //do logic
        if (result.Success === true) {
          this.props.onToaster({ success: true }, "Success: Painting Updated");
          this.setState({
            paintingName: "",
            title: "",
            medium: "",
            sizeValue: "",
            sizeId: 0,
            price: 0,
            discount: 0,
            isSold: false,
            isLoading: false,
            redirect: true,
            selectedSize: null,
          });
        } else {
          this.props.onToaster({ error: true }, "Error: " + result.Message);
          this.setState({ isLoading: false });
        }
      }
    };
    //handle errors
    const errorCallback = (error: AxiosError): void => {
      if (error) {
        this.setState({ isLoading: false });
        this.setState({ isLoading: false }, () => {
          this.props.onToaster(
            { error: true },
            error.response ? error.message : "Unknown Error"
          );
        });
        if (
          error.response &&
          error.response.status &&
          error.response.status === 401
        ) {
        }
      }
    };
    MakeRequest({
      url: "Admin/UpdatePainting",
      method: "post",
      data: { postData: data },
      successCallback,
      errorCallback,
      EncType: data.EncType,
    });
  }
  handleBlurValidation = (e: any) => {
    let errors = Validator({ fields: e.target });
    if (errors.length === 0) {
      this.setState({ formErrors: [] }, () => {
        resetValidationErrors(e.target);
      });
    } else {
      this.setState({ formErrors: errors }, () => {
        showValidationErrors(this.state.formErrors);
      });
    }
  };

  handleFocus = (e: any) => {
    this.setState({ formErrors: [] }, () => {
      resetValidationErrors(e.target);
    });
  };

  handleImageChange = (e: any) => {
    if (e !== null && e !== undefined) {
      this.setState({ image: e.target.files[0] });
    }
  };

  handleTitleChange = (e: any) => {
    if (e !== null && e !== undefined) {
      let clean = sanitizeInput(e.target.value, e.target.type);
      this.setState({ title: clean });
    }
  };

  handlePriceChange = (e: any) => {
    if (e !== null && e !== undefined) {
      this.setState({ price: parseFloat(e.target.value) });
    }
  };

  handleDiscountChange = (e: any) => {
    if (e !== null && e !== undefined) {
      this.setState({ discount: parseFloat(e.target.value) });
    }
  };

  handleMediumChange = (e: any) => {
    if (e !== null && e !== undefined) {
      let clean = sanitizeInput(e.target.value, e.target.type);
      this.setState({ medium: clean });
    }
  };

  handleSizeChange = (e: any) => {
    this.setState({ sizeValue: e.label, sizeId: e.value, selectedSize: e });
  };

  handleCheckBoxChange = (e: any) => {
    this.setState({ isSold: e.target.checked });
  };

  handlePaintingUpdate = (e: any) => {
    if (e !== null && e !== undefined) {
      e.preventDefault();
      this.setState({ isLoading: true });
      const title: string = this.state.title.trim();
      const size: string = this.state.sizeValue.trim();
      const sizeId: number = this.state.sizeId;
      const medium: string = this.state.medium.trim();
      const price: number = this.state.price;
      const discount: number = this.state.discount;
      const isSold: boolean = this.state.isSold;
      const image: any = this.state.image;
      let form = document.getElementById("adminPaintingForm");
      let allFormElements = getAllFormElements({ element: form ? form : e });
      let errors = Validator({ fields: allFormElements });

      //do size format check
      ///\d{2} [xX] \d{2}/gm is 00 X 00
      let pattern = size.search(/\d{2} [xX] \d{2}/gm);
      if (pattern === -1) {
        let error = {
          fieldName: "size",
          message: "Size should follow this format e.g 40 X 40",
        };
        errors?.push(error);
      }

      if (errors.length === 0) {
        //update state
        let paintingDetails: any = {
          PaintingName: this.state.paintingName,
          PaintingId: this.props.paintingId,
          Title: title,
          Size: size,
          SizeId: sizeId,
          Medium: medium,
          Price: price,
          Discount: discount,
          IsSold: isSold,
          Image: image,
          EncType: e.target.enctype,
        };
        this.setState({ formErrors: [] }, () => {
          resetValidationErrors(e.target);
          //save the data
          this.postData(paintingDetails);
        });
      } else {
        this.setState({ isLoading: false, formErrors: errors }, () => {
          showValidationErrors(this.state.formErrors);
        });
      }
    }
  };
  handleDeleting(e: any): void {
    e.preventDefault();
    this.props.onDelete(e);
  }
  componentDidMount(): void {
    if (this.props.paintingId === null || this.props.paintingId === undefined) {
      this.setState({
        renderCount: this.state.renderCount + 1,
      });
    } else {
      this.loadSizes();
      this.loadData();
    }
  }
  render() {
    return (
      <div className="col-md-5 col-sm-6">
        <div className="card-form">
          <h5 className="card-title">Update Painting</h5>
          <div className="container">
            <div className="row">
              <div className="col-md-12">
                <SmallSpinner
                  isLoading={this.state.isLoading}
                  actionText="Please Wait"
                />
              </div>
            </div>
          </div>
          <ValidationSummary Errors={this.state.formErrors} />
          <form
            id="adminPaintingForm"
            onSubmit={this.handlePaintingUpdate}
            encType="multipart/form-data"
          >
            <div className="form-group">
              <label htmlFor="file" className="label-dark">
                Image
              </label>
              <input
                className="form-control border-input"
                type="file"
                id="file"
                name="file"
                onChange={this.handleImageChange}
                accept="image/png, image/jpeg, image/jpg"
                placeholder="Painting image"
                data-required="false"
                data-validationname="file"
                data-id="file"
              />
            </div>
            <div className="form-group">
              <label htmlFor="title" className="label-dark">
                Painting Title
              </label>
              <input
                id="title"
                className="form-control border-input"
                type="text"
                value={this.state.title || ""}
                onChange={this.handleTitleChange}
                onBlur={this.handleBlurValidation}
                onFocus={this.handleFocus}
                placeholder="Painting title"
                data-required="true"
                data-validationname="Painting title"
                data-id="title"
              />
            </div>
            <div className="form-group">
              <label htmlFor="price" className="label-dark">
                Price
              </label>
              <input
                id="price"
                className="form-control border-input"
                type="number"
                value={this.state.price || 0}
                onChange={this.handlePriceChange}
                onBlur={this.handleBlurValidation}
                onFocus={this.handleFocus}
                placeholder="Price"
                data-required="true"
                data-min="1"
                data-validationname="Price"
                data-id="price"
              />
            </div>
            <div className="form-group">
              <label htmlFor="discount" className="label-dark">
                Discount (%)
              </label>
              <input
                id="discount"
                className="form-control border-input"
                type="number"
                value={this.state.discount || 0}
                onChange={this.handleDiscountChange}
                onBlur={this.handleBlurValidation}
                onFocus={this.handleFocus}
                placeholder="Discount"
                data-required="false"
                data-validationname="Discount"
                data-id="discount"
              />
            </div>

            <div className="form-group">
              <label htmlFor="medium" className="label-dark">
                Medium
              </label>
              <input
                id="medium"
                className="form-control border-input"
                type="text"
                value={this.state.medium || ""}
                onChange={this.handleMediumChange}
                onBlur={this.handleBlurValidation}
                onFocus={this.handleFocus}
                placeholder="Medium"
                data-required="true"
                data-validationname="Medium"
                data-id="medium"
              />
            </div>
            <div className="form-group">
              <label htmlFor="sizes" className="label-dark">
                Size
              </label>
              <Select
                key={"sizes_" + this.state.renderCount}
                id="sizes"
                value={this.state.selectedSize}
                defaultValue={this.state.selectedSize || "Select"}
                onChange={this.handleSizeChange}
                options={sizeOptions}
                styles={getCustomStyles()}
              />
            </div>
            <div className="form-group">
              <div className="form-group">
                <Checkbox
                  key={"isSoldKey_" + this.state.renderCount}
                  id="isSold"
                  label="Is Sold?"
                  checked={this.state.isSold || false}
                  onSelecting={this.handleCheckBoxChange}
                  datarequired={false}
                  labelClass="label-dark"
                  data-validationname="Is Sold"
                  data-id="isSold"
                />
              </div>
            </div>
            <div className="card-footer">
              <button
                className="btn btn-success btn-round"
                data-id="updateBtn"
                type="submit"
              >
                Update Painting
              </button>
              &nbsp;
              <button
                className="btn btn-danger btn-round"
                type="button"
                onClick={this.handleDeleting}
                data-tooltip-content="Delete Painting"
                data-toggle="modal"
                data-target="#smallAlertModalUser"
                data-id={this.props.paintingId}
              >
                Delete Painting
              </button>
            </div>
          </form>
        </div>

        {this.state.redirect && <Redirect path="/" />}
      </div>
    );
  }
}

export default PaintingAdminForm;
